<template>
  <div style="display:table;margin:0 auto;">
    <b-spinner label="Spinning" :class="sizeClass" style="color:#51cbce;margin:20px 0;"/>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    size: {
      type: String,
      default: 'md'
    }
  },

  data () {
    return {
      sizeClass: ''
    }
  },

  watch: {
    size: function () {
      this.displaySize()
    }
  },

  created () {
    this.displaySize()
  },

  methods: {
    displaySize () {
      if (this.size === 'md') {
        this.sizeClass = 'spinner-md'
      } else if (this.size === 'sm') {
        this.sizeClass = ' spinner-sm'
      } else if (this.size === 'lg') {
        this.sizeClass = 'spinner-lg'
      }
    }
  }
}
</script>
